(function () {
    'use strict';

    angular
        .module('services.notification', [])
        .factory('notificationService', service);

    service.$inject = ['$mdToast', '$injector'];

    function service($mdToast, $injector) {

        function displayToast(message, type, options) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .content(message)
                    .position('top right')
                    .hideDelay($injector.get('govNotificationDelay'))
                    .action('OK')
                    .theme(type)
            );

            // Unless specified, scroll to top to show toaster
            if (!_.get(options, 'preventScroll', false)) {
                window.scrollTo(0, 0);
            }
        }

        return {
            /**
             * Display a Toast notification.
             * @param message {string} - content of the notification
             * @param [options] {object} - Options to set, see info on displayToast
             * @param [options.preventScroll] {boolean} Set to true to stop auto-scroll to top when showing toaster
             */
            notify: function(message, options) {
                displayToast(message, 'primary', options);
            },

            /**
             * Display a Warning Toast notification.
             * @param message {string} - content of the notification
             * @param [options] {object} - Options to set, see info on displayToast
             * @param [options.preventScroll] {boolean} Set to true to stop auto-scroll to top when showing toaster
             */
            warn: function(message, options) {
                displayToast(message, 'danger', options);
            }
        }
    }
})();